import ConfirmPassword from '@pages/confirm-password/confirm-password';
export default ConfirmPassword;
